import { API_URL } from "./Config";
import { formatDate, formatDateForFiltering } from "./DateUtils";
import { PageResult, PageRequest } from "./Pagination";

export interface ICompliance {
  compliancerecord_id: string;
  type: string;
  reference: string;
  subject: string;
  status: string;
  date: string;
  licence_id: string;
  profile_id: string;
  related_compliance_recordid: string;
  licenceregno: string;
  profilenumber: string;
}

export interface IComplianceList extends PageResult {
  list: ICompliance[];
}

export interface IComplianceRecordType {
  type: string;
}

export interface IComplianceRecordTypesList extends PageResult {
  list: IComplianceRecordType[];
}

export interface IComplianceStatus {
  status: string;
}

export interface IComplianceStatusesList extends PageResult {
  list: IComplianceStatus[];
}

export const GetComplianceListFetchUrl = (
  profileId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  var params = `&page=${pageNo}&per_page=${recordsPerPage}&order_by=date[desc]`;

  var filterParams = "";
  if (filters) {
    for (var i = 0; i < filters.length; i++) {
      var f = filters[i];
      let filterId = f.id;
      if (filterId === "licenceregno") {
        filterId = "activelicence";
        filterParams += `&${filterId}=${f.value}`;
      } else if (filterId === "date") {
        const date_from = formatDateForFiltering(f.value[0]);
        if (f.value[1]) {
          const date_to = formatDateForFiltering(f.value[1]);
          filterParams += `&date_from=${date_from}&date_to=${date_to}`;
        } else {
          const date_to = formatDateForFiltering(f.value[1]);
          filterParams += `&date_from=${date_from}&date_to=${date_to}`;
        }
      } else {
        filterParams += `&${filterId}=${f.value}`;
      }
    }
  }

  if (searchText && searchText.length > 0) {
    filterParams += `&search_term=${encodeURIComponent(searchText)}`;
  }

  let url = `${API_URL}/ComplianceList/compliancelist?licence_profile_id=${profileId}${filterParams}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/compliancelist`;
  }

  return url;
};

export function FormatComplianceList(rows: Array<any>) {
  return rows.map((item) => {
    return <ICompliance>{
      compliancerecord_id: item.compliancerecord_id,
      date: formatDate(item.date),
      licence_id: item.licence_id,
      licenceregno: item.licenceregno,
      profile_id: item.profile_id,
      profilenumber: item.profilenumber,
      reference: item.reference,
      related_compliance_recordid: item.related_compliance_recordid,
      status: item.status,
      subject: item.subject,
      type: item.type,
    };
  });
}

export async function GetComplianceRecordTypesAsync(
  profileId: string
): Promise<IComplianceRecordTypesList> {
  let url = `${API_URL}/ComplianceList/compliancerecordtypesbyprofile?licence_profile_id=${profileId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/compliance-record-types`;
  }

  var response = await fetch(url);
  var body = <IComplianceRecordTypesList>await response.json();
  body.list = body.list.map((item) => {
    return <IComplianceRecordType>{
      type: item.type,
    };
  });
  return body;
}

export async function GetComplianceRecordStatusesAsync(): Promise<IComplianceStatusesList> {
  let url = `${API_URL}/ComplianceList/compliancerecordstatus`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/compliance-record-status`;
  }

  var response = await fetch(url);
  var body = <IComplianceStatusesList>await response.json();
  body.list = body.list.map((item) => {
    return <IComplianceStatus>{
      status: item.status,
    };
  });
  return body;
}

export async function GetComplianceListByProfileIdAsync(
  profileId: string,
  pageRequest: PageRequest
): Promise<IComplianceList> {
  const url = GetComplianceListFetchUrl(
    profileId,
    pageRequest.page,
    pageRequest.per_page,
    "",
    null
  );

  var response = await fetch(url);
  var body = <IComplianceList>await response.json();
  body.list = body.list.map((item) => {
    return <ICompliance>{
      compliancerecord_id: item.compliancerecord_id,
      date: formatDate(item.date),
      licence_id: item.licence_id,
      licenceregno: item.licenceregno,
      profile_id: item.profile_id,
      profilenumber: item.profilenumber,
      reference: item.reference,
      related_compliance_recordid: item.related_compliance_recordid,
      status: item.status,
      subject: item.subject,
      type: item.type,
    };
  });
  return body;
}

export const GetComplianceListDummy = (profileId: string): IComplianceList => {
  return {
    count: 1,
    length: 50,
    page: 1,
    list: [],
  };
};
